<div id="cookie-banner" *ngIf="showBanner"
    style="position: fixed;width: 100%;background: #333;color: white;padding: 15px;text-align: center;font-size: 14px;bottom: 0; z-index: 9999;">
    Questo sito utilizza solo cookie tecnici per il corretto funzionamento. Se non intendi autorizzare, chiudi la
    pagina.
    <button (click)="acceptCookies()"
      style="background: #ff9800; color: white; border: none; padding: 8px 12px; margin-left: 10px; cursor: pointer; font-size: 14px;">OK</button>
</div>
